import axios from "@/libs/http";

/**
 * 获取我的资料
 */
export const getLeader = () => {
    return axios.request({
        url: '/s/l/leader/get',
        params: {
        },
        method: 'get'
    })
}

/**
 * 修改状态
 */
export const updateLeaderStatus = (status) => {
    return axios.request({
        url: '/s/l/leader/updateStatus',
        params: {
            status
        },
        method: 'post'
    })
}

/**
 * 获取组长下的店员列表
 */
export const getClerkList = (clerkName) => {
    return axios.request({
        url: '/s/l/leader/getClerkList',
        params: {
            clerkName
        },
        method: 'post'
    })
}

/**
 * 获取订单续单申请列表
 */
export const continuedApplyList = (status, keyword, pageNo, pageSize) => {
    let data = new URLSearchParams()
    if (status != null) {
        data.append("status", status)
    }
    if (keyword != null) {
        data.append("keyword", keyword)
    }
    data.append("pageNo", pageNo)
    data.append("pageSize", pageSize)
    return axios.request({
        url: '/s/l/leader/continuedApplyList',
        data,
        method: 'post'
    })
}

/**
 * 审核
 */
export const verifyOrderContinuedApply = (id, status, reason) => {
    return axios.request({
        url: '/s/l/leader/verify',
        params: {
            id,
            status,
            reason
        },
        method: 'post'
    })
}
